<template>
  <div>
    <b-img
      :src="question.options.image_url"
      :alt="question.options.image_alt"
      fluid
      class="w-100"
    ></b-img>
  </div>
</template>

<script>
  export default {
    props: {
      value: Object, // answer
      question: Object,
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: String,
        default: 'md',
      },
    },
    data() {
      return {
        trans: trans,
        answer: null,
      }
    },
  }
</script>